const INFO = {
	main: {
		title: "Dive",
		name: "Dive.",
		email: "divedevadas@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		twitter: "https://twitter.com/",
		github: "https://github.com/",
		linkedin: "https://www.linkedin.com/in/divedevadas",
		instagram: "https://www.instagram.com/divedevadas/?hl=en",
		stackoverflow: "https://stackoverflow.com/",
		facebook: "https://facebook.com/",
		calendly: "https://calendly.com/divedevadas/",
	},

	homepage: {
		title: "Sr. Recruitment Consultant",
		description:
			"As a Recruitment Consultant, I bring a wealth of experience in travel (W2), perm placements, and locum tenens recruitment, with a strong focus on lead generation, candidate screening, client relationship management, negotiation, and documentation. I am highly skilled in sourcing candidates across a range of platforms, including Vivian Job Diva, Indeed, Facebook, Health Job Nation, Broadbean, Monster, and LinkedIn, enabling me to connect top-tier talent with the right opportunities",
	},

	about: {
		title: "I’m Dive Devadas,",
		description:
			"As a Recruitment Consultant, I bring a wealth of experience in travel (W2), permanent placements, and locum tenens recruitment. I'm skilled in lead generation, candidate screening, client relationship management, negotiation, and documentation. I source top-tier talent using platforms like Vivian Job Diva, Indeed, Facebook, Health Job Nation, Broadbean, Monster, and LinkedIn. Certified in Nexus ATS, I streamline recruitment processes and enhance efficiency. I’m proficient in Workday, SAP Fieldglass, Vector, ShiftWise, and Magnit, and I have experience navigating 45+ VMS/MSP platforms. I also specialize in US compliance, credentialing, timesheet management, and employee relations. Currently pursuing a PhD in Business Management with a focus on HR, I hold an MBA with dual specializations in HR and Marketing. Let’s connect to discuss how I can support your recruitment goals.",
	},
	

	articles: {
		title: "Empowering Recruitment Excellence and Shaping Strategic HR Landscapes.",
		description:
			"Chronological collection of my in-depth thoughts and industry insights on talent acquisition, healthcare staffing, HR strategies, VMS tools, and tourism management.",
	},
	

	projects: [	
		{
			title: "Arzoo Godara – Recruitment Manager – Cynet Health",
			description:
				"Dive is an enthusiastic and talented recruiter who consistently delivers results. His strong interpersonal skills and ability to work under pressure are truly commendable...",
			logo: "../arzoo.jpg",
			linkText: "LinkedIn Profile",
			link: "https://www.linkedin.com/in/arzoo-godara-290773185/",
		},
		{
			title: "Shruti Anand – Assistant Manager – L&D",
			description:
				"Dive is a gem to work with. His empathetic nature and strong communication skills make him a great recruiter. He takes time to understand both the client's and the candidate's needs, ensuring a perfect match. Dive’s strategic approach and problem-solving skills are commendable...",
			logo: "../shruriii.jpg",
			linkText: "LinkedIn Profile",
			link: "https://www.linkedin.com/in/shruti-anand-303095b4/",
		},
		{
			title: "Mohak Puri – Recruitment Manager – Cynet Health",
			description:
				"Dive’s enthusiasm and passion for recruitment are truly inspiring. He approaches every task with energy and positivity. His proactive attitude and ability to adapt to changing situations make him a reliable and effective recruiter...",
			logo: "../Mohak.jpg",
			linkText: "LinkedIn Profile",
			link: "https://www.linkedin.com/in/mohak-puri-63a481188/",
		},
		{
			title: "Prachi Saklani – Assistant Manager – Training Programs, Cynet Corp",
			description:
				"Dive has an exceptional ability to connect with people and understand their needs. His recruitment strategies are both creative and effective. He is always willing to go the extra mile to ensure client and candidate satisfaction...",
			logo: "../Prachi.jpg",
			linkText: "LinkedIn Profile",
			link: "https://www.linkedin.com/in/prachi-saklani-07411b198/",
		},
		{
			title: "Krishna Jaswal – Recruitment Manager – Cynet Health",
			description:
				"Dive is an exceptional recruiter with a keen eye for talent. His communication skills and ability to build rapport with candidates are outstanding...",
			logo: "../Krishna.jpg",
			linkText: "LinkedIn Profile",
			link: "https://www.linkedin.com/in/krishna-jaswal-8b530598/",
		},
		{
			title: "Anuj Trehan – Delivery Lead – Healthcare Hiring",
			description:
				"Dive’s professionalism and knowledge in the healthcare recruitment domain are impressive. He consistently delivers high-quality work and ensures a seamless recruitment process...",
			logo: "../Van.jpg",
			linkText: "LinkedIn Profile",
			link: "https://www.linkedin.com/in/anuj-trehaan-1bba1b106/",
		},
	],
};

export default INFO;
